import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import Icon from '../Icon'
import ActionButton from '../ActionButton'
import CDeclarationTable from '../DeclarationTable'

export const Container = styled.div`
  ${breakpoints.up('desktop')} {
  }
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`

export const StyledIcon = styled(Icon)`
  width: 4rem;
  height: 4rem;
  color: ${({ theme }) => theme.colors.royalBlue};
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.H4};
`

export const Actions = styled.div<{ $isMobile?: boolean }>`
  display: ${({ $isMobile }) => ($isMobile ? 'flex' : 'none')};
  margin-top: ${({ $isMobile }) => ($isMobile ? '1.6rem' : '0')};
  gap: 0.8rem;

  ${breakpoints.up('tablet')} {
    display: ${({ $isMobile }) => ($isMobile ? 'none' : 'flex')};
  }
`

export const Action = styled(ActionButton)``

export const DeclarationTable = styled(CDeclarationTable)``
